// extracted by mini-css-extract-plugin
export default {"discardPile":"DiscardPile_discardPile__fzL3b"};